module.exports = __webpack_public_path__ + "static/media/Majin_Streamer.b8aef59e.jpeg";